import type { Options } from 'ky';

import { initData } from '@tma.js/sdk-react';

import { getApiUrl } from 'src/shared/utils/get-api-url';

import { baseApi } from '../base-api';
import { refreshAccessToken } from './refresh-access-token';

import type {
  IGetTokenResponse,
  IVerifyCallRequest,
  IVerifyCodeRequest,
  IVerifyCallResponse,
  ISendCodeSmsRequest,
  ISendCodeCallRequest,
  ISendCodeSmsResponse,
  ISendCodeCallResponse,
  ISendCodeTelegramRequest,
  ISendCodeTelegramResponse,
} from './types';

const api = baseApi.extend({
  prefixUrl: `${getApiUrl(2)}/Auth`,
});

const readJsonSafe = async <T>(response: Response): Promise<T | null> => {
  try {
    const text = await response.text();
    if (!text) {
      return null;
    }

    return JSON.parse(text) as T;
  } catch {
    return null;
  }
};

export const apiAuth = {
  tgAuth: async () => {
    const telegramHash = initData.hash()?.trim();
    const telegramInitData = initData.raw()?.trim();
    const response = await api.get('TgAuth', {
      headers: {
        ...(telegramHash ? { 'X-Telegram-Hash': telegramHash } : {}),
        ...(telegramInitData ? { 'X-Telegram-InitData': telegramInitData } : {}),
      },
    });

    await response.text();
  },
  sendCodeTelegram: async (data: ISendCodeTelegramRequest, options?: Pick<Options, 'signal'>) =>
    await api
      .post<ISendCodeTelegramResponse>('send-code-telegram', { json: data, ...options })
      .json(),
  sendCodeCall: async (data: ISendCodeCallRequest) =>
    await api.post<ISendCodeCallResponse>('send-code-call', { json: data }).json(),
  verifyCall: async (data: IVerifyCallRequest) => {
    const response = await api.post('verify-call', { json: data });
    return await readJsonSafe<IVerifyCallResponse>(response);
  },
  sendCodeSms: async (data: ISendCodeSmsRequest) =>
    await api.post<ISendCodeSmsResponse>('send-code-sms', { json: data }).json(),
  verifyCode: async (data: IVerifyCodeRequest) => {
    const response = await api.post('verify-code', { json: data });
    await response.text();
  },
  refreshToken: refreshAccessToken,
  /** Токен для подключения к чат-хабу (другой origin, куки не доходят). */
  getToken: async () => await api.get<IGetTokenResponse>('getToken').json(),
  logout: async () => await api.post('logout'),
};
